import React, { useMemo } from 'react';

import { useDispatch } from 'react-redux';
import * as chatActions from 'modules/chat';

import ChatHeader from "./ChatHeader";
import ChatItemCont from "./ChatItemCont";


const ChatItem = ({ data, style, index }) => {
  const { date, roomInfo, writerInfo, contents } = data;

  // data = {
  //   key: 날짜 + 방아이디,
  //   date: 시간
  // roomInfo: 방정보,
  //  writerInfo:  작성자,
  //   contents: [챗정보],
  // }

  const dispatch = useDispatch();

  if (1 === 2) { console.log(dispatch, chatActions) }  //삭제예정

 
  const domContList = useMemo(() => contents.map(
      chat => <ChatItemCont key={chat.chat_id} headerData={{roomInfo, writerInfo, date}} data={chat} />
    ),[contents, roomInfo, writerInfo, date]);


  const domChatItem = useMemo(()=>{
    if (contents.length === contents.filter(chat => chat.web_post_hide_yn === 'Y').length) {
      return null;
    }

    return (
      <div className="subject" style={style}>
        <ChatHeader roomInfo={roomInfo} writerInfo={writerInfo} date={date} />
        {domContList}
      </div>
    )
  },[roomInfo, writerInfo, date, style, domContList, contents]);


  
  return (
    domChatItem
  )
}


export default ChatItem;